import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  background-color: #f5f5f5;

  padding: 1rem;

  font-family: "Mulish";

  gap: 1rem;

  .header {
    font-size: 1.2rem;
    font-weight: bold;
    span {
      color: #3751ff;
    }
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 95%;

  gap: 2rem;

  .top-wrapper {
    display: flex;
    position: relative;

    justify-content: center;

    width: 100%;
    height: 5%;
  }
  .back-icon {
    width: 2rem;
    height: 2rem;

    position: absolute;
    left: 0.5rem;

    cursor: pointer;

    transition: 0.5s;

    :hover {
      width: 2.5rem;
      height: 2.5rem;

      color: #3751ff;
    }
  }
  a {
    color: black;
  }

  .search-bar {
    display: flex;

    width: 50%;
    height: 3rem;

    border-radius: 1rem;

    background-color: white;

    align-items: center;

    padding: 0 1rem 0 1rem;

    input {
      width: 100%;
      height: 100%;

      padding: 0 0 0 1rem;

      font-size: 1rem;

      border: none;
      background-color: white;
    }
  }

  .process-wrapper {
    display: flex;
    flex-direction: column;

    width: 95%;
    height: 15%;

    gap: 1rem;

    margin-top: 1%;

    justify-content: center;
  }
  .content {
    display: flex;
    background-color: white;

    width: 100%;

    border-radius: 1rem;
  }

  .process {
    display: flex;
    flex-direction: column;

    width: 100%;

    background-color: white;

    border-radius: 1rem;

    tr {
      display: flex;

      width: 100%;
      height: 4rem;

      font-size: 0.9rem;

      border-bottom: #dfe0eb 1px solid;

      white-space: nowrap;

      align-items: center;
      justify-content: center;

      :last-child {
        border-bottom: none;
      }
    }

    th,
    td {
      display: flex;

      width: 100%;
      height: 2rem;

      align-items: center;
      justify-content: center;

      font-size: 1rem;
    }
  }

  .bottom-wrapper {
    display: flex;

    width: 95%;
    height: 75%;

    gap: 1rem;
  }

  .left-bottom {
    display: flex;
    flex-direction: column;

    width: 60%;
    height: 100%;

    gap: 1rem;
  }

  #asw-response {
    display: flex;
    flex-direction: column;

    height: 50%;

    padding: 1rem;
  }

  .asw-header {
    height: 10%;
  }

  .asw-doc {
    display: flex;

    width: 100%;
    height: 100%;

    align-items: center;
    justify-content: center;

    button {
      width: 15rem;
      height: 4rem;

      padding: 1rem;

      border-radius: 1rem;
      border: none;

      background-color: #3751ff;
      color: white;

      font-size: 1rem;
      font-weight: bold;

      transition: 0.35s;
      cursor: pointer;

      :hover {
        background-color: #0021fd;
        width: 17rem;
        height: 5rem;
      }
    }
  }

  #analitics {
    display: flex;

    height: 50%;

    align-items: center;
    justify-content: center;

    p {
      color: #3751ff;
      font-size: 2rem;
      font-weight: bold;
    }
  }

  .right-bottom {
    width: 40%;
    height: 100%;
  }

  #content-doc {
    display: flex;
    flex-direction: column;

    height: 100%;

    padding: 1rem;
  }

  .doc-wrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(4, 1fr);

    width: 100%;
    height: 48.5rem;

    overflow: auto;

    padding: 1rem;
    gap: 1rem;

    div {
      display: flex;
      flex-direction: column;

      height: 10rem;

      align-items: center;

      padding: 1rem;

      border: 2px #3751ff solid;
      border-radius: 1rem;

      gap: 1rem;

      p {
        font-weight: bold;

        text-align: center;
      }

      img {
        width: 5rem;
      }
    }
  }
`;
